import { PostboxDocumentType as PostboxDocumentTypeShared, PostboxDocument } from 'cpes-common';

export type AllDocumentType = 'ALL';

export type PostboxDocumentType = PostboxDocumentTypeShared | AllDocumentType;

export const documentTypeTranslationMapping: Record<PostboxDocumentType, string> = {
    ALL: 'all',
    CARDIF_INSURANCE_POLICY: 'cardif-insurance-policy', // 28
    CONSUMER_CREDIT_INFORMATION: 'consumer-credit-information',
    FINANCING_CONTRACT: 'financing-contract',
    INVOICE: 'invoice',
    LONG_DRIVE_SERVICE_CONTRACT: 'long-drive-service-contract', // 26
    PARTICULAR_CONDITIONS: 'particular-conditions',
    SEPA_MANDATE: 'sepa-mandate',
    WELCOME_LETTER: 'welcome-letter',
    LEASING_INVOICE: 'leasing-invoice',
    BILLING_REPORT: 'billing-report',
    MASTER_AGREEMENT: 'master-agreement',
};

export type AvailableDocument = {
    type: PostboxDocumentType;
    translation: string;
};

const invoiceDocumentTypes: PostboxDocumentType[] = ['INVOICE', 'LEASING_INVOICE'];

export const isInvoiceTabDocument = (document: PostboxDocument): boolean =>
    invoiceDocumentTypes.includes(document.type);

export const resolveInvoiceDocumentType = (postboxDocuments: PostboxDocument[]): PostboxDocumentType | undefined =>
    postboxDocuments.find(document => invoiceDocumentTypes.includes(document.type))?.type;

export const getListOfAvailableDocumentTypes = (postboxDocuments: PostboxDocument[]): AvailableDocument[] => {
    const listOfAvailableDocuments: AvailableDocument[] = [
        { type: 'ALL', translation: documentTypeTranslationMapping['ALL'] },
    ];
    postboxDocuments.forEach(document => {
        if (!listOfAvailableDocuments.find(o => o.type === document.type)) {
            listOfAvailableDocuments.push({
                type: document.type,
                translation: documentTypeTranslationMapping[document.type] || document.type,
            });
        }
    });
    return listOfAvailableDocuments;
};
